import * as ENUM from "./enums";
import * as FIELD_NAME from "./fieldNames";

export const PRODUCT_NAME = "µPULSE";
export const EMAIL_SUPPORT = "support@formulatrix.com";
export const WEIGHT_UNLOAD_CHECKBOX = "Weight is Unloaded";
export const CONFIRM_CHECKBOX = "Yes, I am sure";
export const PROFILE = {
  SUCCESS_SAVE_PROFILE: "Your profile has been saved successfully.", // v
  UNCOMPLETE_FIELDS:
    "You must fill in all of the required fields. Tap RESUME to continue with the profile setup or DISCARD to close the page without saving your profile.", // v
  LEAVE_PROFILE_SETUP:
    "You are about to leave the profile setup. Do you want to save the changes?", // v
  DELETE_PROFILE:
    "Are you sure you want to remove <profile name> from the Explorer? ", // v
  FIELD_ERROR: {
    // renge message implement to Numpad
    // STARTING_VOLUME_RANGE: "The " + FIELD_NAME.STARTING_VOLUME + " value must be at least 1 but not more than 50 mL.",//v
    // STARTING_CONCENTRATION_RANGE: "The " + FIELD_NAME.STARTING_CONCENTRATION + " value must be at least 0.0001 but not more than 100 mg/mL.",//v
    // FINAL_VOLUME_RANGE: "The " + FIELD_NAME.FINAL_VOLUME + " value must be at least 0.2 but not more than 50 mL.",//v
    // FINAL_VOLUME_REALATION_WITH_STARTING_VOLUME: "The " + FIELD_NAME.FINAL_VOLUME + " value must be lower than the " + FIELD_NAME.STARTING_VOLUME + ".",//v
    // ESTIMATE_FINAL_CONCENTRATION_RELATION_WITH_STARTING_CONCENTRATION: "The " + FIELD_NAME.FINAL_CONCENTRATION + " value must be higher than the " + FIELD_NAME.STARTING_CONCENTRATION + " value. ",//V
    IMPOSSIBLE_ESTIMATED_FINAL_CONCENTRATION: `Unable to achieve the ${FIELD_NAME.FINAL_CONCENTRATION}. ${PRODUCT_NAME} will automatically set the ${FIELD_NAME.FINAL_VOLUME} to {minFinalVolume} mL and recalculate the configurations. `, // v
    // VOLUME_TO_START_RANGE: "The " + FIELD_NAME.VOLUME_TO_START_AT + " value must be at least 1 but not more than 50 mL.",//v
    // VOLUME_TO_START_RELATION_WITH_STARTING_VOLUME: "The " + FIELD_NAME.VOLUME_TO_START_AT + " value must be lower than the " + FIELD_NAME.STARTING_VOLUME + " value.",//V
    // VOLUME_TO_START_RELATION_WITH_FINAL_VOLUME: "To use the " + FIELD_NAME.DIAFILTRATION + " option, \n the " + FIELD_NAME.VOLUME_TO_START_AT + " value must be higher than the Final Volume value.",//v
    // TOTAL_VOL_TO_START_AND_BUFFER_VOLUME_TO_USE: "The total of the " + FIELD_NAME.VOLUME_TO_START_AT + " value and the " + FIELD_NAME.BUFFER_VOLUME_TO_USE + " value must not exceed 50 mL.",//v
    // BUFFER_VOLUME_TO_USE_RELATION_WITHTOTAL_BUFFER_VOLUME: "The " + FIELD_NAME.BUFFER_VOLUME_TO_USE + " value must be lower than the Total Buffer Volume value.",//v
    // TOTAL_BUFFER_VOLUME_TO_USE_LESS_THAN_THRESHOLD: "Buffer Recovery requires Total Buffer Volume to be equal or higher than Buffer Volume to Use + 3",
  },
  DIAFILTRATION_CONTINUES_ERROR: `To use the Diafiltration-Continuous option, the ${FIELD_NAME.VOLUME_TO_START_AT} value must be higher than the Final Volume value.`,
  VOLUME_START_SAMPLE_RANGE:
    "The value of Sample Volume to Start Exchange too near to critical maximum volume. Sample tube overflow might happen.",
  NOTE_RESET: "*reset to value from System Settings",
  STOP_PROFILE: {
    TITLE: "Stop Profile Options",
    CONTENT:
      "You're about to stop the profile. \n Please select the option below to confim your action.",
  },
  LEFT_CONICAL_MISSING:
    "Left Conical Size is not selected. \n Select one of the options from the dropdown list.",
  LEFT_CONICAL_INVALID:
    "Invalid parameters. Adjust your Starting Volume and \n Final Volume with your conical tube selection.",
  NUMPAD: {
    [FIELD_NAME.FINAL_VOLUME]: {
      INFO: " (not more than Starting Volume)",
    },
    [FIELD_NAME.FINAL_CONCENTRATION]: {
      INFO: " (more than Starting Concentration)",
    },
  },
};

export const VOLUME_DIFFERENCE = {
  TITLE: "Volume Differences",
  TEXT: `${PRODUCT_NAME} has detected some differences between the input volume and the sensor measurement volume.\nPlease modify the volume in the tube or change the input volume below.`,
};
export const BUFFER_EXCHANGE = {
  NEED_REFILL: {
    TITLE: "Exchange Volume",
    TEXT: "The Exchange Volume you have entered ({EXCHANGE_VOLUME} out of {BUFFER_VOLUME} mL) requires a refill in the middle of the profile execution, 3 mL of current buffer volume is kept in the tube as safe volume.\nDo you want to continue?",
  },
  IS_NOT_50ML_TUBE: {
    TITLE: "Current Buffer Volume",
    TEXT: "The Current Buffer Volume you have entered ({INPUT} mL) is greater than the standard 50 mL tube.\nPlease CONFIRM you are using a 125 mL bottle, or CANCEL to re-enter the Buffer Volume.",
  },
  REFILL: {
    TITLE: "Refill Buffer Volume",
    TEXT:
      // "The system has used {BUFFER_USED} mL of buffer solution out of the required {EXCHANGE_VOLUME} mL of Exchange Volume.\n\n" +
      // "Please refill the buffer solution ({BUFFER_NEEDED} mL) and input the volume below, tap CONTINUE to execute buffer exchange process, tap STOP to finish the profile, or tap CANCEL to continue the profile without buffer exchange.",
      "The system has used {BUFFER_USED} mL of buffer solution out of the required {EXCHANGE_VOLUME} mL of Exchange Volume.\n" +
      "Please refill the tube with the total {BUFFER_NEEDED} mL and input the volume below. Then, tap CONTINUE to execute the buffer exchange process.\n" +
      "Tap STOP to finish the profile or tap CANCEL to continue the profile without buffer exchange.",
    // TEXT: "The system has only 1 mL of buffer solution out of the required 3 mL.\n\nPlease refill the tube to reach the required volume below. Tap CONTINUE to execute the buffer recovery or tap BACK to go to the recovery options.",
    NOTE: "The maximum buffer volume is {MAX_VOLUME} mL. Please fulfill the remaining of the required volume buffer.",
    REFILL_BUFFER: "Refilled Buffer Volume",
    SENSOR: "Measured Volume",
  },
  CALCULATOR: {
    TITLE: "Buffer Exchange Calculator",
    WARNING:
      "The Necessary Exchange Volume must be between {MIN} and {MAX} mL.",
  },
};

export const MANUAL_PROFILE = {
  FIELD_ERROR: {
    FILE_NAME_USED: "Manual Profile name is already used",
    FILE_NAME_CONTAIN_SYMBOLS: "Can't use symbol in file name",
    FILE_NAME_CANNOT_BE_EMPTY: "The Manual Profile name can't be empty.",
  },
};

export const ADV_SETUP = {
  SUCCESS_SAVE_ADV_SETUP: "Your profile has been saved successfully.", // v
  UNCOMPLETE_FIELDS:
    "You must fill in all of the required fields. Tap RESUME to continue with the profile setup or DISCARD to close the page without saving your profile.", // v

  LEAVE_ADV_SETUP_SAVE_TITLE: "Save Setup", // v
  LEAVE_ADV_SETUP_SAVE_AS_TITLE: "Save Setup As", // v
  LEAVE_ADV_SETUP_SAVE:
    "Changes have been made in the Advanced Setup.\nDo you want to save this changes?", // v
  LEAVE_ADV_SETUP_SAVE_AS:
    "Changes have been made in the Advanced Setup.\nDo you want to save this changes?", // v

  ADV_SETUP_RENAME_TITLE: "Rename Setup",
  WARNING_INFO: {
    TOO_LONG: "The file name is too long",
    SYMBOL: "Can’t use symbol in file name",
    EMPTY: "The Advanced Setup Name cannot be empty.",
  },

  DELETE_ADV_SETUP:
    "Are you sure you want to remove <advSetup name> from the Explorer? ", // v
  FIELD_ERROR: {
    FILE_NAME_CONTAIN_SYMBOLS: "Can't use symbol in file name",
    FILE_NAME_CANNOT_BE_EMPTY: "The Advanced Setup Name cannot be empty.",
    FILE_NAME_ALREADY_EXIST: "The Advanced Setup name is already used",
  },
};
export const NOT_MATCH_INPUT_AND_SENSOR = {
  PROTEIN_VOLUME:
    "“The Starting Volume value is <higher/lower> than the volume sensor reading. The maximum tolerance value is 5 mL.”",
  BUFFER_VOLUME:
    "The Buffer Volume to Use value is lower than buffer volume sensor reading. The input value should be equal to or higher than the buffer volume sensor reading.",
};

export const CYCLE = {
  FINISH: "The cycle has been completed.", // v
  STOP: "The cycle has been stopped at {xx} mL of Protein Volume and {yy} mg/mL of Protein Concentration.", // V
  PRIMING_IS_TOO_LONG: `The Priming cycle has stopped due to taking longer than expected. Please check the ${PRODUCT_NAME} and try again.`,
  CONCENTRATING_IS_TO_LONG: `The Concentrating cycle has stopped due to taking longer than expected. Please check the ${PRODUCT_NAME} and try again.`,
  DIAFILTRATION_IS_TO_LONG: `The Diafiltrating cycle has stopped due to taking longer than expected. Please check the ${PRODUCT_NAME} and try again.`,
  OTHER_ERROR:
    "The cycle has stopped due to an unexpected error. Click here to view the error report.",
};
export const READ_VOLUME_SENSOR = "Reading the volume sensor"; // v
export const VOLUME_SENSING_ERROR = {
  DETEACH_TUBE: `An error occurred while reading the Volume Sensor.\n<SENSORVALUE>\nPlease detach your sample and buffer tubes from the ${PRODUCT_NAME}, and press Try Again.`, // v
  PUT_TUBE:
    "You can now attach your sample and buffer tubes to the corresponding inputs and press Continue.", // v
};

export const PIN = {
  INVALID_PIN:
    "The PIN is incorrect. Please input the correct PIN and try again.", // v
};

export const UPDATE = {
  UPDATE_TYPE: "Please select update method you want to use :", // v
  DETACHED_TUBE: "I have already detached the tubes.", // v
};

export const SOFTWARE_UPDATE = {
  CHECK_INTERNET_CONNECTION: "Checking your internet connectivity", // v
  NEW_VERSION_FOUND: `A new version of ${PRODUCT_NAME}{UPDATE_TYPE} available. Would you like to upgrade now?\n\nTo see what's new in this release,\nvisit the {What's-New-Page}.`,
  NO_NEW_VERSION: `You're already enjoying the latest version of ${PRODUCT_NAME}!`, // v
  DOWNLOADING: `Please wait while ${PRODUCT_NAME} downloads the new {DownloadType} update...{...}%`, // v
  SUCCESS_UPDATE: `${PRODUCT_NAME} has updated successfully!`,
  NO_INTERNET_CONNECTION: `${PRODUCT_NAME} was unable to check for a software update. Please check your internet connection and try again.`, // v
  TIME_OUT:
    "The downloading process is taking longer than expected. Please check your internet connection and try again.", // v
  STOP_DOWNLOAD_BINARY: `${PRODUCT_NAME} currently downloading newest version.`, // v
  STOP_DOWNLOAD_VERSION: `${PRODUCT_NAME} currently checking version.`, // v
  STOP_DOWNLOAD_QUESTION: "What do you want to do with this process?", // v
  PREPARING_DOWNLOAD_UPDATE: "Preparing download update \nPlease wait", // ?
  PREPARING_INSTALL_UPDATE: "Preparing installing update \nPlease wait", // ?

  SHUTTING_DOWN: "Shutting down",
  CHEKING_FILE: "Checking file",
  CHEKING_USB_DRIVE: "Checking your USB Drive", // v
  MOUNT_USB_DRIVE: "Mounting USB Drive", // x
  DOWNLOAD_CANCEL: "Download Canceled", // x
  INSTALLING:
    "Installing new {updateOperations}\n {updateAction} : {updatePercentage} %", // x
  RESTARTING: "Restarting",

  MODAL_NEED_RESTART: {
    TITLE: "Restart Instrument",
    TEXT: "Restart the instrument in order to implement your updates. Do you want to restart now?",
  },
  ALLERT: {
    UPDATE_WHEN_RESTART:
      "Update will be implemented when you restart the device later on",

    UPDATE_OFFLINE: {
      [ENUM.SOFTWARE_UPDATE_ERROR.OUTDATED]: {
        TITLE: "Downgrade µPULSE Version",
        TEXT: `The ${PRODUCT_NAME} version in this file is older than the current version. You can downgrade the version or upload another file.\n\nAre you sure you want to downgrade the version?`,
        BUTTON: "DOWNGRADE",
      },
      [ENUM.SOFTWARE_UPDATE_ERROR.SAME_VERSION]: {
        TITLE: "Re-install µPULSE Version",
        TEXT: `The ${PRODUCT_NAME} version in this file has already been installed. You can reinstall this version or upload another file.\n\nAre you sure you want to reinstall this version? `,
        BUTTON: "RE-INSTALL",
      },
      [ENUM.SOFTWARE_UPDATE_ERROR
        .CORRUPTED]: `Unable to update the ${PRODUCT_NAME} because the file is corrupted. Please select another file and try again.`,
      [ENUM.SOFTWARE_UPDATE_ERROR
        .LICENSE_EXPIRED]: `Unable to update the ${PRODUCT_NAME}.\nPlease activate the license and try again.`,
      [ENUM.SOFTWARE_UPDATE_ERROR
        .INVALID_TIME]: `Unable to update the ${PRODUCT_NAME} because the time setting is wrong (backdate). Please adjust the time setting and try again.`,
    },
    UPDATE_ONLINE: {
      [ENUM.SOFTWARE_UPDATE_ERROR
        .OUTDATED]: `You're already enjoying the latest version of ${PRODUCT_NAME}!`,
      [ENUM.SOFTWARE_UPDATE_ERROR
        .CORRUPTED]: `Unable to update the ${PRODUCT_NAME} because the downloaded file is corrupted.\nPlease repeat the online update process.`,
      [ENUM.SOFTWARE_UPDATE_ERROR
        .LICENSE_EXPIRED]: `Unable to update the ${PRODUCT_NAME}.\nPlease activate the license and try again.`,
      [ENUM.SOFTWARE_UPDATE_ERROR
        .INVALID_TIME]: `Unable to update the ${PRODUCT_NAME} because the time setting is wrong (backdate). Please adjust the time setting and try again.`,
      [ENUM.SOFTWARE_UPDATE_ERROR.DOWNLOAD_TIMEOUT]:
        "The downloading process is taking longer than expected. Please check your Internet connection and try again.",
      [ENUM.SOFTWARE_UPDATE_ERROR
        .NO_INTERNET]: `${PRODUCT_NAME} was unable to check for a software update. Please check your internet connection and try again.`,
    },
  },
};

export const PROFILE_HISTORY = {
  EXPORTING_PROFILE_HISTORY: "Exporting profile history",
  ERROR_EXPORT_STORAGE_FULL:
    "Unable to export the Profile History due to insufficient storage",
  ERROR_EXPORT: "Failed to export the Profile History",
  SUCCESS_EXPORT: "Profile History has been exported successfully!", // v
  OPEN_DETAIL_LOADING: "Opening Profile History",
  GET_HISTORY_LIST_DATA: "Getting the Profile History Data",
};

export const SYSTEM_LOG = {
  EXPORTING_SYSTEM_LOG: "Exporting System Log",
  ERROR_EXPORT_STORAGE_FULL:
    "Unable to export the System Logs due to insufficient storage",
  ERROR_EXPORT: "Failed to export the System Logs",
  SUCCESS_EXPORT: "System Logs has been exported successfully!",
  NO_FOLDER_FOUND: "No folder found",
  STORE_LOGS_HERE: "Tap EXPORT to store logs here",
};

// TODO: some of the message was too general
export const EXPORT_IMPORT = {
  CHECKING_USB_DRIVE: "Checking USB drive", // x
  FLASH_DRIVE_NOT_FOUND:
    "Unable to find the USB drive. Make sure that you have connected it into the USB port and try again.",
  FAILED_GET_FLASH_DRIVE: "Failed get the USB drive info.",
  SUCCESS_EXPORT: "Export successfully!", // v
  ERROR_EXPORT: "Unable to export due to insufficient storage",
};

export const IS_TUBE_ATTACHED = {
  TITLE: `${PRODUCT_NAME} Detects Weight on Scales`,
  TEXT: `Please unload the weight on both scales and tick the checkbox below to let the ${PRODUCT_NAME} tare the scales.`,
  CHECKBOX: WEIGHT_UNLOAD_CHECKBOX,
  TUBE_DETECTED: `${PRODUCT_NAME} still detects weight on scales.`,
  // TITLE: PRODUCT_NAME + " tare the scales",
  // TEXT: "Please unload the weight on both scales and tick the checkbox below to let the " + PRODUCT_NAME + " tare the scales.",
  // CHECKBOX: WEIGHT_UNLOAD_CHECKBOX,
  // TUBE_DETECTED: PRODUCT_NAME + " still detects weight on scales.",
};
export const SHUTDOWN =
  "Ensure that you have removed the chip and the tubes from the instrument.\n\n Are you sure you want to turn off the instrument?"; // v
export const SHUTTINGDOWN = "Shutting down";

export const CLEANING_WIZARD = {
  LEAVE_WIZARD:
    "You are about to leave the Cleaning Wizard. \n Do you want to continue?", // v
  QUIT_OR_CONTINUE_WIZARD: `${PRODUCT_NAME} is currently running a cleaning cycle. \nTap CONTINUE to resume the cleaning cycle, or tap QUIT to stop the cycle and exit the Cleaning Wizard .`, // v
  // STOP_OR_CONTINUE_WIZARD: PRODUCT_NAME + " is currently running a cleaning cycle. \nTap CONTINUE to resume the cleaning cycle, or tap STOP to stop the cycle.",
  STOP_OR_CONTINUE_WIZARD:
    "The system is currently running a Cleaning Cycle. \nAre you sure want to Stop a Cleaning Cycle?",
  STOPPED_CLEANING_CYCLE: "The Cleaning Cycle has been stopped",
  STOP_OR_CONTINUE_RINSE:
    "The system is currently running a Rinsing Cycle. \nAre you sure want to Stop a Rinsing Cycle?",
  STOPPED_RINSE_CYCLE: "The Rinse Cycle has been stopped",
};

export const CALIBRATION_WIZARD = {
  NO_TUBE_TEXT: `Make sure neither of the tubes are attached to the ${PRODUCT_NAME} instrument. Then tap SAVE to record the capacitance value.`, // v
  EMPTY_TUBE_TEXT: `Insert both tubes into the ${PRODUCT_NAME}, insert the calibration chip, then select SAVE to record the values.`, // replaced by Baker. Gitlab 106 //"Attach both tubes to the " + PRODUCT_NAME + " instrument, then select SAVE to record the capacitance value.",//v
  INITIAL_TEXT:
    "Fill each tube with %VOLUME% mL of distilled water or buffer solution. Then select SAVE to record the capacitance value.", // v
  VOLUME_CALIBRATION_TEXT:
    "Remove solution on both tubes until the remaining volume is %VOLUME% mL and select SAVE to record the capacitance value.", // v
  SENSOR_CALIBRATION_FINISH:
    "Sensor Plate Calibration is finished, tap NEXT to proceed to the next step.", // v
  REFERENCE_CALIBRATION_FINISH:
    "Reference Plate Calibration is finished, tap NEXT to proceed to the next step.", // v,
  SUCCESS_UPDATE: "Your calibration values have been updated!", // v
};
export const CALIBRATION_LOAD_CELL_WIZARD = {
  CHECK_SCALES: `Make sure that there is <strong>no weight applied to both scales<strong> before tapping ${FIELD_NAME.TARE.toUpperCase()}.\nIf you <strong>find any inaccuracy<strong> in either sample or buffer scale, tap ${FIELD_NAME.CALIBRATE_SCALES.toUpperCase()} to proceed to the calibration`,
  NO_TUBE_TEXT: `Make sure that there is <strong>no weight applied to both scales<strong>.\nTap ${FIELD_NAME.TARE.toUpperCase()} to tare the system and tap NEXT to continue.`,
  SAMPLE_TUBE_TEXT: `Put the ${FIELD_NAME.CALIBRATION_WEIGHT.toLowerCase()} on the center of the sample scale (left input).\nIf you don’t have a ${FIELD_NAME.CALIBRATION_WEIGHT.toLowerCase()}, fill a tube with 20-50 mL of water.\n<strong>Measure the weight of the tube that’s filled with water and the tube stand to 2 decimal place accuracy.<strong>\nThen install the tube on the sample scale.\n\nInput the ${FIELD_NAME.CALIBRATION_WEIGHT.toLowerCase()} in the box below.\nTap ${FIELD_NAME.CALIBRATE.toUpperCase()} and let the ${PRODUCT_NAME} calibrate the sample scale.\nTap NEXT to continue to the next step.`,
  BUFFER_TUBE_TEXT: `<strong>Move the ${FIELD_NAME.CALIBRATION_WEIGHT.toLowerCase()}<strong> to the Buffer Scale (right input).\nTap ${FIELD_NAME.CALIBRATE.toUpperCase()} and let the ${PRODUCT_NAME} calibrate the buffer scale.\nTap NEXT to continue to the next step.`,
  CALIBRATION_FINISH_TEXT: `Tap FINISH to complete the calibration process and save the values.\nIf you see a significant difference (more than 1 gram) in value between the ${FIELD_NAME.CALIBRATION_WEIGHT.toLowerCase()}\nand the ${FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT.toLowerCase()}, please contact <strong>${EMAIL_SUPPORT}<strong> for assistance.`,
  EXIT_PAGE:
    "You are about to leave the Calibration Wizard.\nTap CONTINUE to resume the calibration process, or tap EXIT to exit and discard the data you have collected.",
  SAMPLE_SCALE: "Sample Scale (Left Input)",
  BUFFER_SCALE: "Buffer Scale (Right Input)",
  TARE_LOADING: "Taring the system",
  CALIBRATION_LOADING: "Calibrate the System",
  TARE_OFFSET_FAILED_TEXT:
    "The scales might be damaged, please check the scales accuracy on the\nSystem Settings > Calibration > Check Scales",
  TARE_FAILED_TEXT: `Unable to tare the system. Please contact ${EMAIL_SUPPORT} for assistance.`,
  TARE_SUCCESS_TEXT: "The instrument has been tared successfully!",
  CALIBRATE_FAILED_TEXT: "The scale calibration has failed",
  // SUCCESS_UPDATE: "Your calibration values have been updated!",
  // FAILED_UPDATE: "Your calibration value failed to update!",
  SUCCESS_UPDATE: "The scale calibration was successfull!",
  FAILED_UPDATE: "The scale calibration was failed",
  RESET_DEFAULT: {
    TITLE: "Reset to Default Calibration",
    // TEXT: "You are about to reset the calibration value to its default value. Unload the weight on both scales and tick the checkbox below.",
    TEXT: "You are about to reset the calibration value to its default value.",
    CHECKBOX: WEIGHT_UNLOAD_CHECKBOX,
    SUCCESS_RESET_DEFAULT:
      "Your current calibration values have been successfully reset to default values.",
    FAILED_RESET_DEFAULT: `Unable to reset the calibration values, please try again. If this problem persists, contact ${EMAIL_SUPPORT} for assistance.`,
  },
  CALIBRATION_HISTORY_LOAD: {
    TITLE: "Updated Successfully",
    // TEXT: "You are about to use the selected Calibration History. Unload the weight on both scales and tick the checkbox below.",
    TEXT: "You are about to use the selected Calibration History. Are you sure you want to load the selected values?",
    SUCCESS_LOAD_CALIBRATION_TARE_OFFSET: `Your current calibration values have been updated, but ${PRODUCT_NAME} detects the scales might be damaged.\nWe recommend you to check the scales.`,
    SUCCESS_LOAD_CALIBRATION:
      "Your current calibration values have been updated successfully.",
    FAILED_LOAD_CALIBRATION: "Unable to load the scale calibration value",
    SUCCESS_LOAD_CALIBRATION_ALLERT:
      "The scale calibration has been loaded successfully!",
    SUCCESS_LOAD_CALIBRATION_TARE_OFFSET_ALLERT:
      "The scales might be damaged.\nGo to SYSTEM SETTINGS > CALIBRATION > CHECK SCALES to check the scales’ accuracy.",
    CHECKBOX: WEIGHT_UNLOAD_CHECKBOX,
  },
  CALIBRATION_HISTORY_DELETE: {
    TITLE: "Delete Selected Calibration",
    TEXT: "You are about to delete the selected Calibration from History. This action can cause loss of valuable settings and can not be undone.\nAre you sure you want to delete it?",
    SUCCESS_DELETE_CALIBRATION:
      "The selected calibration history has been successfully removed",
    FAILED_DELETE_CALIBRATION: "Failed delete Your calibration values.",
    CHECKBOX: CONFIRM_CHECKBOX,
  },
  RECALIBRATION: {
    TITLE: "Recalibration",
    TEXT: "Please recalibrate the system before use.",
  },
};

export const CALIBRATION_HISTORY = {
  ID: "Id",
  IS_ACTIVE: "IsActive",
  DATE_TIME: "CalibrationDate",
  SAMPLE_SCALE: "ProteinScale",
  SAMPLE_REF_WEIGHT: "ProteinRefWeight",
  SAMPLE_OFFSET: "ProteinOffset",
  BUFFER_SCALE: "BufferScale",
  BUFFER_REF_WEIGHT: "BufferRefWeight",
  BUFFER_OFFSET: "BufferOffset",
  DATE: "Date",
  TIME: "Time",
  TARE_OFFSET: "Tare Offset",
  SCALE_SLOPE: "Scale Slope",
  SAMPLE_WEIGHT: "SAMPLE WEIGHT",
  SAMPLE_SCALE_SLOPE: "SAMPLE SCALE SLOPE",
  BUFFER_WEIGHT: "BUFFER WEIGHT",
  BUFFER_SCALE_SLOPE: "BUFFER SCALE SLOPE",
  SUCCESS_UPDATE: "Your calibration values have been updated!", // v
  SELECT_CALIBRATION_HISTORY:
    "You are about to use the selected values as the calibration values. \n Do you want to continue?", // v
};

export const CYCLE_PROCESS = {
  DEPRESSURIZING: "Depressurizing the system", // v
  RECOVERY_THE_LIQUID: "Recovering the liquid", // v
  RECOVERY_THE_LIQUID_WITH_PROGRESS:
    "Recovering the liquid... {...}%\n{CURRENT_RECOVERY} Recovery",
  SWITCH_TO_MANUAL_CONTROL: "Switching to manual control",
};

export const MANUAL_CONTROL = {
  TITLE: FIELD_NAME.MANUAL_CONTROL,
  POP_UP_READY_MANUAL_CONTROL:
    "The device has stopped early and it is now ready for manual control to finish the operation. Select OK to proceed.",
  // POP_UP_BUTTON_SWITCH_MANUAL_CONTROL: "You are about to switch to the manual control execution. Tap CONTINUE to proceed or CANCEL to continue your profile execution.", //v
  POP_UP_BUTTON_SWITCH_MANUAL_CONTROL:
    "Please confirm switching from automatic control to manual control.",
  TAP_HELP_BUTTON: "Tap the Help button {ICON} for more information.",
  NUMPAD: {
    CUSTOM_MANUAL_CONTROL: {
      INFO: " (not more than Current Sample Volume)",
    },
  },
};

export const MANUAL_CONTROL_THRESHOLD_WARNING = {
  TITLE: "Safety Threshold Warning",
  CONTENT:
    "The Auto Profile will immediately switch to Manual Control because the Starting Volume and Final Volume difference is close to the Safety Threshold. You can change the Safety Threshold setting in the Advanced Setup.\n\nAre you sure you want to continue?",
};
export const MANUAL_CONTROL_RECOVERY_OF_LIQUID = {
  MESSAGE_SUCCESS: "Select your hold-up recovery method.",
  // "You’re about to run a liquid recovery to complete the profile execution.\n\nSelect one of the liquid recovery options below, then tap PROCEED to initiate the recovery process. Select FINISH to skip the liquid recovery.", //v
  MESSAGE_ERROR:
    "An error has occured, the cycle will be stopped. You are about to run a liquid recovery to complete the profile execution.\n\n Please select one of the liquid recovery options and select CONTINUE.", // v
  TITLE: "Recovery of Liquid",
  TITLE_ERROR: "Error - Recovery of Liquid",
  TITLE_SAMPLE_RECOVERY: "Sample Recovery",
};

export const VOLUME_SENSING_MISMATCH = {
  MESSAGE: "Enter the starting volume below.", // v
};

export const TUBE_AVAILABILITY_CHECK = {
  WAITING_TUBE: "Waiting for tubes and chip to be inserted",
  TUBE_DETECTED: "Sample and Buffer tube detected.",
  SAMPLE_TUBE_DETECTED: "Sample tube detected.",
  PLEASE_WAIT: "Please wait",
  KEEP_TUBE_NOT_INSERTED: "Please don't insert the tubes",
  TUBE_NOT_DETECTED:
    "Sample and Buffer tube not detected.\nPlease remove chip and tubes from the system and then\n press CONFIRM to reset measurement.",
  SAMPLE_TUBE_NOT_DETECTED:
    "Sample tube not detected.\nPlease remove chip and tubes from the system and then\n press CONFIRM to reset measurement.",
  CHECK_SYSTEM: "Checking the system", // v
};

export const VOLUME_SENSOR_READLINESS = {
  WAITING_READY: "Checking the volume sensor.", // v
};

export const DEVICE_ELEMENT_NOT_COMPLETE =
  "Device Element is not complete. Please check availability of Permeate bottle, Permeate Collector, Chip, Tube";

export const DEVICE_ELEMENT_CHECK = {
  CHECK_SYSTEM: "Checking the system", // v
  WASTE_BOTTLE: {
    DETECTED: "Permeate bottle detected", // v
    NOT_DETECTED: "Permeate bottle not detected", // v
  },
  WASTE_DRAINAGE: {
    DETECTED: "Permeate collector detected", // v
    NOT_DETECTED: "Permeate collector not detected", // v
  },
  CHIP: {
    DETECTED: "Chip detected", // v
    NOT_DETECTED: "Chip not detected", // v
  },
};

export const VOLUME_SENSOR_STABILITY_CHECK = {
  CHECK_SYSTEM: "Checking stability of volume sensor.",
  NOT_STABLE: {
    TITLE: "Volume Sensor isn't stable",
    TEXT: "Volume Sensor isn't stable, it may affect the accuracy of sensor reading",
  },
};

export const MIXING_CYCLE = {
  RUNNING: "Mixing the Liquid",
};

export const SYSTEM_SETTING = {
  SUCCESS_CHANGE_SETTING: "Changes have been saved successfully.", // v
  LEAVE_WITH_UNSAVE_CHANGE:
    "You are about to leave the System Setting menu.\nDo you want to save your changes?", // v
  NO_SYNCRONIZE_TIMEZONE:
    "Unable to synchronize timezone. Please check your internet connection and try again.",
  NO_SYNCRONIZE_DATETIME:
    "Unable to synchronize date time. Please check your internet connection and try again.",
  CYCLE_THRESHOLD: {
    EXIT_PAGE: {
      TITLE: "Cycle Threshold",
      TEXT: "You are about to exit the cycle threshold.", // v
      QUESTION: "Do you want to continue?", // v
    },
    CHANGES_SAVED: "Changes saved", // v
  },
  DEVICE_SETTING: {
    EXIT_PAGE: {
      TITLE: "Device Setting",
      TEXT: "You are about to exit the device setting.", // v
      QUESTION: "Do you want to continue?", // v
    },
    SAVE_DEVICE_SETTING: {
      TITLE: "Save Device Setting", // v
      TEXT: "Reboot the instrument to apply changes in the Device Settings.", // v
      TEXT_BACK:
        "At least one change is being made in Device Setting. \nDo you want to save this change?",
    },
    DEVICE_NAME_UPDATE: {
      TITLE: "Device Name Update", // v
      TEXT: `${PRODUCT_NAME} must reboot to update the device name. \nDo you want to reboot now?`, // v
    },
    FIELD_ERROR: {
      FILE_NAME_CONTAIN_SPACE: "The Device Name cannot contain spaces.",
      FILE_NAME_CONTAIN_SYMS_SPACES: "Name can't contain spaces and symbols.",
      FILE_NAME_CANNOT_BE_EMPTY: "The Device Name cannot be empty.",
      ORGANIZATION_CANNOT_BE_EMPTY: "The Organization cannot be empty.",
      USERNAME_LENGTH_AND_SYMBOL:
        "Username must be between 8 to 20 characters and can’t contain symbols.",
      PASSWORD_LENGTH_AND_SYMBOL:
        "Password must be at least 8 characters and can’t contain symbols.",
      USERNAME_CANNOT_ADMIN: `You can’t use “admin” as your username. Please enter other username.`,
      PASSWORD_CANNOT_SAME_AS_USERNAME: `Password cannot be the same as username.`,
    },
  },
  GENERAL_SETTING: {
    EXIT_SAVE_PAGE: {
      TITLE: "Save General Settings",
      TEXT: "At least one change is being made in General Settings.",
      QUESTION: "Do you want to save this changes?",
      SAVE_SUCCESS: "General Settings have been updated successfully!",
    },
    FIELD_ERROR: {
      FILE_NAME_CANNOT_BE_EMPTY: "The U cannot be empty.",
      USERNAME_PASSWORD_CANNOT_BE_EMPTY:
        "Both username and password field must be filled to continue saving.",
      USERNAME_CANNOT_BE_EMPTY:
        "Username field must be filled to continue saving.",
      USERNAME_LENGTH_AND_SYMBOL:
        "Username must be between 8 to 20 characters and can’t contain symbols.",
      PASSWORD_LENGTH_AND_SYMBOL:
        "Password must be at least 8 characters and can’t contain symbols.",
      USERNAME_CANNOT_ADMIN: `You can’t use “admin” as your username. Please enter other username.`,
      PASSWORD_CANNOT_SAME_AS_USERNAME: `Password cannot be the same as username.`,
    },
  },
  PRESSURE_SETTING: {
    // EXIT_PAGE: {
    // 	TITLE: "Pressure Setting",
    // 	TEXT: "You are about to exit the pressure setting.",
    // 	QUESTION: "Do you want to continue?",
    // },
    SAVE: {
      TITLE: `Save Default ${FIELD_NAME.BOTTLE_PRESSURE}s`,
      TEXT: `At least one change is being made in Default ${FIELD_NAME.BOTTLE_PRESSURE}. This will affect ALL DEFAULT PRESSURES used in profiles. Any changes could cause worse results. Do you want to save this change(s)?`,
      SUCCESS: "The default values have been updated successfully!",
      FAILED: "The values you changed have been discarded.",
      DISCARD: "The values you changed have been discarded.",
    },
    RESET_DEFAULT: {
      TITLE: "Restore All Defaults",
      TEXT: "Restoring the default values will delete all settings you have made.\nAre you sure you want to continue?",
    },
  },
  THRESHOLD_SETTING: {
    // EXIT_PAGE: {
    // 	TITLE: "Threshold Setting",
    // 	TEXT: "You are about to exit the threshold setting.",
    // 	QUESTION: "Do you want to continue?",
    // },
    SAVE: {
      TITLE: "Save Volume Changes Threshold",
      TEXT: "At least one change is being made in Volume Changes Threshold.\nDo you want to save this changes?",
      SUCCESS: "The default values have been updated successfully!",
      FAILED: "The values you changed have been discarded.",
      DISCARD: "The values you changed have been discarded.",
    },
    RESET_DEFAULT: {
      TITLE: "Restore All Defaults",
      TEXT: "Are you sure you want to restore all defaults Volume Changes Threshold?",
    },
    NOTES:
      "Note: The system will not check the volume change threshold if you set the value to 0.",
  },
  WIFI: {
    FORGET: "Forget",
    CONNECT: "Connect",
    CHECKBOX: "Connect Automatically",
    WIFI_UNAVAILABLE:
      "Wifi is currently turned off.\nIf you want to use the wifi, please tap “Turn On”",
    ALLERT: {
      SUCCESS_FORGET: "Success Forget Wifi",
      FAILED_FORGET: "Failed Forget Wifi",
      PASSWORD_INCORRECT: "Password Incorrect",
      PASSWORD_AND_SSID_INCORRECT:
        "Unable to connect to this network.\nPlease check your SSID and Password.",
      CONNECTION_TIME_OUT: "The connection has timed out",
      UNABLE_TO_JOIN:
        "Unable to connect to this network.\nPassword may be incorrect, please try another password.",
    },
    SAVE: "Save",
  },
};
export const RETURN_VALVE_PRESSURE_SETTINGS = {
  TITLE: "Return Valve Pressure",
  TEXT: "",
  QUESTION: "",
};

export const NUMPAD = {
  MAX_DIGIT:
    "Maximum number after the decimal point is {NUMBER_OF_DIGIT} digits.", // v not used, hardcoded in FmlxNumpad
  MIN_PASSWORD: "Minimum Password is 1 digit",
};

export const ERROR_PAGE = {
  TITLE: "Something went wrong", // v not used, hardcoded in FmlxNumpad
  RESTART_TEXT: `There has been an error that can't be recovered.\nPlease restart your system to see if it fixes the problem\nor contact <strong>${EMAIL_SUPPORT}<strong> if the problem persists.`,
  RESTART_BUTTON: "RESTART",
  RELOAD_TEXT: `There has been an error.\nPlease reload the page to see if it fixes the problem\nor contact <strong>${EMAIL_SUPPORT}<strong> if the problem persists.`,
  RELOAD_BUTTON: "RELOAD",
};
export const DEVICE_NOT_CONNECT_PAGE = {
  TITLE: "Device Not Connected", // v not used, hardcoded in FmlxNumpad
  TEXT: `A connection error occurred.\nPlease check your instrument connection and then <strong>restart<strong> your browser.\nContact <strong>${EMAIL_SUPPORT}<strong> if the problem persists.`,
  BUTTON: "Restart",
};

// License
export const LICENSE = {
  MODAL: {
    TITLE: "License Activation",
    TEXT: "Please select the license activation method:",
  },
  MODAL_TRIAL: {
    TITLE: "License Activation",
    TEXT: `Activate your license to get full access to your ${PRODUCT_NAME} functionality.`,
    // TITLE: "License Activation",
    // TEXT:
    //   "Activate your license to get full access to your " +
    //   PRODUCT_NAME +
    //   " software and hardware functionality. Tap ACTIVATE to activate your license now or tap LATER to postpone the activation and run the system in demo mode only. Then, go to the INFO & SUPPORT menu to activate your license later on.",
  },
  MODAL_DEMO: {
    TITLE: "License Activation",
    TEXT: `Activate your license to get full access to your ${PRODUCT_NAME} functionality.`,
    // "You are running " +
    // PRODUCT_NAME +
    // " in demo mode because the license is not active or the temporary license has expired. Tap ACTIVATE to activate license or contact <strong>" +
    // EMAIL_SUPPORT +
    // "<strong> for further assistance.",
  },
  STATUS: {
    [FIELD_NAME.LICENSE.STATUS.ACTIVE]: "Activated",
    [FIELD_NAME.LICENSE.STATUS.EXPIRED]: "Expired",
    [FIELD_NAME.LICENSE.STATUS.NO_LICENSE]: "Not activated",
  },
  TYPE: {
    [FIELD_NAME.LICENSE.TYPE.TEMPORARY]: "Trial",
    [FIELD_NAME.LICENSE.TYPE.PERMANENT]: "Perpetual",
    [FIELD_NAME.LICENSE.TYPE.UNKNOWN]: "-",
  },
  ACTIVATION_MODE: {
    ONLINE: {
      TITLE: "Online activation",
      TEXT: `Input the client ID that you have received via email and tap ACTIVATE to activate your license. If you have not received an email with your client ID, please contact <strong>${EMAIL_SUPPORT}<strong> for assistance.`,
    },
    OFFLINE: {
      TITLE: "Manual activation",
      TEXT: `The license file is sent to your email. Make sure that you have moved the file to your USB drive. Tap ACTIVATE to activate the license.\nNote: If you haven't received an email, please contact our support at <strong>${EMAIL_SUPPORT}<strong> for assistance.`,
    },
    TRIAL: {
      TITLE: "Trial activation",
      TEXT: "A trial license can only be activated once. It will expire {NUMBER_OF_DAY} days after its activation and it causes system to stop working.\nTap ACTIVATE to start your trial license.",
    },
  },
  NO_INTERNET: "no internet connection",
  FIELD_ERROR: {
    CONTAIN_SPACE: "The Client ID cannot contain spaces.",
    INVALID_CLIENT_ID: "Invalid format, please check your client ID",
    CANNOT_BE_EMPTY: "The Client ID Name cannot be empty.",
    CLIENT_ID_NOT_VALID: `This client ID is invalid. Please contact support at ${EMAIL_SUPPORT} for assistance.`,
  },
  ALLERT: {
    SUCCESS: "License has been activated successfully!",
    FAILED: "License activated failed!",
    TRIAL_SUCCESS: "The Trial License has been activated successfully!",
    FAILED_ONLINE:
      "Unable to activate license. Please check your internet connection and try again",
    FAILED_OFFLINE: `The license file is invalid. Please contact support at ${EMAIL_SUPPORT} for assistance.`,
    FAILED_OFFLINE_INVALID: `The license file is invalid. Please contact support at ${EMAIL_SUPPORT} for assistance.`,
    FAILED_OFFLINE_INVALID_DEVICE: `The license file does not match the instrument's serial number. Please contact our support at ${EMAIL_SUPPORT} for assistance.`,
    FAILED_INFO: "Failed Get License Info!",
    DEMO: `This screen only shows a simulation, the ${PRODUCT_NAME} hardware will not execute the profile. Activate your license in the INFO & SUPPORT menu for full access to your ${PRODUCT_NAME} software and hardware functionality.`,
    TRIAL_DAY_LEFT: `Your trial license will expire in {NUMBER_OF_DAY} days.\nPlease contact ${EMAIL_SUPPORT} to purchase a perpetual license.`,
  },
};

// Remote Support
export const REMOTE_SUPPORT = {
  MODAL: {
    TITLE: "Remote Support",
    TEXT: `Contact <strong>${EMAIL_SUPPORT}<strong> to get remote support for your device. Tap <strong>AUTHORIZE<strong> to allow the support team to access your device.`,
    WARNING:
      "Make sure you have a stable internet connection to do this action.",
    BUTTON: {
      AUTHORIZE: "AUTHORIZE",
      CANCEL: "CANCEL",
    },
  },
  LOADING: {
    AUTHORIZE: "Authorizing device support",
    REMOVE_AUTHORIZE: "Removing the support authorization",
  },
  ALLERT: {
    // NO_INTERNET_CONNECTION: "Unable to Authorize. Please check your internet connection and try again.",
    NO_INTERNET_CONNECTION:
      "An error occurred during the authorization. Make sure you have a stable internet connection. Contact support@formulatrix.com if the problem persists.",
  },
  PAGE: {
    TITLE: "Remote Support", // v not used, hardcoded in FmlxNumpad
    TEXT: "The support team is currently accessing your system.\nDon't turn off the instrument and make sure you have a stable internet connection during the Remote Support process.",
    BUTTON: "DISCONNECT",
    CHECKBOX: "Restart the device",
  },
};

export const PRESSURE_RUN_TOO_LONG_MESSAGE =
  "The pressure or vacuum pump has been running for too long. Check for chip leakage. Consult the Troubleshooting guide in the µPULSE web help.";

export const DATA_COLLECTION = {
  AUTHENTICATION_SETUP_POPUP: {
    TITLE: "Data Collection Authentication Setup",
    TEXT: "To ensure data collection on your remote device is secure, set up authentication in General Settings.",
  },
};

export const AUTO_RECOVERY_INFO = {
  TITLE: "Auto Recovery",
  TEXT: (
    <>
      <p>
        When Auto Recovery is active, the system automatically performs sample
        recovery using a combination of air + buffer + air.
      </p>
      <br />
      <p>Important note:</p>
      <b>Concentration & Buffer Exchange</b>
      <ul>
        <li>Fill the right tube with at least 2 mL of buffer.</li>
        <li>Recovery may increase the final volume by up to 0.5 mL.</li>
      </ul>
      <b>Concentration (2 Tubes)</b>
      <ul>
        <li>Recovery uses air only (no buffer required).</li>
      </ul>
      <b>Safety Threshold</b>
      <ul>
        <li>Safety threshold is ignored when Auto Recovery is enabled.</li>
      </ul>

      <p>
        Please confirm all conditions are met to ensure a successful recovery.
      </p>
    </>
  ),
};

export const HIGH_VOLUME_BUFFER_INFO = {
  TEXT: (
    <ul>
      <li>
        High volume buffer is only active during the Buffer Exchange process.
      </li>
      <li>If High Volume Buffer ON, may reduce buffer volume accuracy.</li>
      <li>Use High Volume Buffer for volumes over 50 ml.</li>
    </ul>
  ),
};
